import {
  PractitionerBilling,
  PractitionerBillingStatus,
  practitionerBillingSchema,
} from "@/models/PractitionerBillingModel.ts";
import { cz } from "@/utils/zodUtils.ts";

import { ApiDataSourceSpec, apiDataSource } from "../datasource/ApiDatasource";

export class BillingRepository {
  constructor(private readonly datasource: ApiDataSourceSpec = apiDataSource) {}

  getBillingFiles = (): Promise<PractitionerBilling[]> =>
    this.datasource.get("practitioner/practitioner-billing/", cz.forcedArray(practitionerBillingSchema));

  changeBillingFileStatus = (billingId: string, status: PractitionerBillingStatus) =>
    this.datasource.post(`practitioner/practitioner-billing/${billingId}/status/`, cz.ignore(), { status });
}
